$(document).ready(function() {
    $('.slick-slider').slick({
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        variableWidth: true,
        prevArrow: '<div class="quote-ico slide-arrow prev-arrow"><svg id="scroller-previous" width="100" height="100" viewBox="0 0 100 100"><use xlink:href="#scroller_previous" fill="" /></svg></div>',
        nextArrow: '<div class="quote-ico slide-arrow next-arrow"><svg id="scroller-next" width="100" height="100" viewBox="0 0 100 100"><use xlink:href="#scroller_next" fill="" /></svg></div>',
    });
});
